import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { v4 as uuidV4 } from 'uuid';
import AssociatedAssets from '../../common/sections/associatedAssets';
const EmployeeAssets = _ref => {
  let _ref$assets = _ref.assets,
    assets = _ref$assets === void 0 ? [] : _ref$assets,
    onChange = _ref.onChange,
    userID = _ref.userID;
  const defaultData = asset => ({
    id: uuidV4().toUpperCase(),
    appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
    assetID: asset.id,
    name: asset.name,
    appCreatorID: userID
  });
  const handleAdd = asset => {
    const items = JSON.parse(JSON.stringify(assets));
    items.push(defaultData(asset));
    onChange('assets', items);
  };
  const handleRemove = index => {
    const parsedAssets = JSON.parse(JSON.stringify(assets));
    parsedAssets.splice(index, 1);
    onChange('assets', parsedAssets);
  };
  const handleChange = (index, name, value) => onChange("assets[".concat(index, "]/").concat(name), value);
  return /*#__PURE__*/React.createElement(AssociatedAssets, {
    assets: assets,
    onChange: handleChange,
    onRemove: handleRemove,
    onAdd: handleAdd
  });
};
EmployeeAssets.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func.isRequired,
  userID: PropTypes.string.isRequired
};
export default EmployeeAssets;